import _ from 'lodash';

const moduleName = 'ProspectingProject';
const modulePath = _.kebabCase(moduleName);

export default {
  moduleName,
  modulePath,
};
